import React, {useState, useEffect} from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import { useCookies } from "react-cookie";
import configVars from "../../../config";
import { getWithExpiry, setWithExpiry } from "../../../common";
import { useTranslation } from "react-i18next";

const ProductivityChart = (props) => {

    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const [translation] = useTranslation("translations");

    const [employeeCost, setEmployeeCost] = useState(520000);
    const [costChanged, setCostChanged] = useState(false);
    const [loading, setLoading] = useState(false);

    const stressRed = props?.hviValues?.red ? props.hviValues.red[1] : 0;
    const stressYellow = props?.hviValues?.yellow ? props.hviValues.yellow[1] : 0;

    const sleepRed = props?.hviValues?.red ? props.hviValues.red[3] : 0;
    const sleepYellow = props?.hviValues?.yellow ? props.hviValues.yellow[3] : 0;

    const totalStressed = stressRed + stressYellow;
    const totalSleepingLess = sleepRed + sleepYellow;

    let stressCost = 0;
    let sleepCost = 0;

    let totalEmployeesCost = employeeCost;

    if ( props?.members &&  props?.members > 1 ) {
        totalEmployeesCost = employeeCost*props?.members;
    }

    if ( totalStressed > 0 ) {
        stressCost = parseInt( ((totalEmployeesCost*totalStressed)/100)*0.09 , 10 );
    }

    if ( totalSleepingLess > 0 ) {
        sleepCost = parseInt(((totalEmployeesCost*totalSleepingLess)/100)*0.12, 10);
    }

    useEffect(() => {

        const savedEmployeeCost = getWithExpiry( `employee_cost_${props?.organization}` );

        if ( savedEmployeeCost ) {
            setEmployeeCost( savedEmployeeCost );
        } else {

            (async () => {

                let userRequestData = new FormData();
                userRequestData.append( 'token', cookies.sustainyou_user_jwt );
                userRequestData.append( 'organization', props?.organization );
                userRequestData.append( 'data_type', 'get' );
    
                const fetchUrl = `${configVars.apiUrl}sustainchange/v1/employeecostupdate/`;
    
                try{
    
                    const response = await fetch(
                        fetchUrl,
                        {
                        method: "POST",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                        body: userRequestData
                        }
                    );
                    
                    const updateResponse = await response.json();
            
                    if ( updateResponse ) {
    
                        if ( updateResponse.success === true ) {
                            setCostChanged(false);
    
                            if ( updateResponse.data?.cost && updateResponse.data?.cost > 0 ) {
                                setEmployeeCost( updateResponse.data?.cost );
                            }
    
                        }
    
    
                    }
    
                } catch( error ) {
                    console.log( error );
                    return error;
                }
    
            })()

        }


    }, [cookies.sustainyou_user_jwt, props]);

    const options = {
        chart: {
            type: 'column'
        },
        title: {
            text: `${translation("cost_calculator")} (SEK)`
        },
        xAxis: {
            categories: [translation("stress_text"), translation("lack_of_sleep")]
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            }
        },
        tooltip: {
            pointFormat: '<span >{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                    enabled: true
                }
            }
        },
        series: [{
            name: translation("productivity_loss"),
            data: [stressCost, sleepCost],
            color: '#B23722',
        }, {
            name: translation("productivity_text"),
            data: [(totalEmployeesCost-stressCost), (totalEmployeesCost-sleepCost)],
            color: '#b99353',
        },]
    };

    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }

    const handleCostChange = (val) => {

        setEmployeeCost(val);
        setCostChanged(true);

    }

    const handleCostUpdate = async () => {

        setLoading(true);

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'cost', employeeCost );
            userRequestData.append( 'organization', props?.organization );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/employeecostupdate/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {

                    if ( updateResponse.success === true ) {
                        setCostChanged(false);
                        setWithExpiry( `employee_cost_${props?.organization}`, employeeCost );
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading(false);

    }

    return(
        <div className="productivity-chart-wrap">
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />

            <div className="bg-white pt-4 px-3 pb-3">
                <label htmlFor="employee_cost" className="form-label">Årskostnad per medarbetare (SEK):</label>
                <input type="number" min="0" className="form-control" id="employee_cost" value={employeeCost} onChange={(e) => handleCostChange(e.target.value)} />
                <div id="emailHelp" className="form-text">Totala beloppet av medelårslön + sociala avgifter/ löneskatt + pension + friskvård + försäkringar + overheadkostnader etc. För en uppskattad total Årskostnad per anställd ta medelårslönen multiplicerat med två.</div>
                
                {costChanged &&
                    <div className="mt-3 d-flex justify-content-end">
                        <button type="button" className="btn btn-primary btn-sm text-white" onClick={() => handleCostUpdate()}>
                            <span className="me-2">Spara årskostnad till organisation</span>

                            {loading &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            }
                            
                            {!loading &&
                                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                            }
                        </button>
                    </div>
                }
                
            </div>
        </div>
    )

}

export default ProductivityChart;